import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getSegmentColorPalette,
  getSelectedSegment,
  getWheelColorPalette,
} from "../redux/selectors/segmentBuilderSelectors";
import { useWheelSegments } from "../contexts/wheelSegments";
import { getSelectedSegmentColor, getSelectedSegmentPalette, getSelectedWheelPalette } from "../redux/selectors/colorPalette";

export const usePaletteColor = () => {
  const url = window.location.href;
  const isViewWheelPage = url.includes("wheel");
  const isMobileView = url.includes("wheel/segment")

  const segmentBuilderSegment = useSelector(getSelectedSegment) || {};
  const { segments,wheelData } = useWheelSegments();

  const wheelPalette = useSelector(getSelectedWheelPalette) //for web view in mobile
  const segmentPalette = useSelector(getSelectedSegmentPalette) //for web view in mobile
  const segmentColor = useSelector(getSelectedSegmentColor)

  const selectedArc =
    (isViewWheelPage
      ? segments.find((seg) => seg.selected)
      : segmentBuilderSegment) || {};

  const { settings: segmentSettings = {} } = selectedArc;
  const { color: selectedSegmentColor } = segmentSettings;
  const segmentColorPalette = useSelector(getSegmentColorPalette);
  const selectedPalette = isMobileView ? segmentPalette :
    (isViewWheelPage ? segmentSettings.paletteData : segmentColorPalette) || {};

  const wheelColorPalette = useSelector(getWheelColorPalette) || {};
  const selectedWheelPalette = isMobileView ? wheelPalette : (isViewWheelPage ? wheelData.palette_data : wheelColorPalette) || {}; 

  const isValidSuggestedColor = (suggestedColorString = "") => {
    return (
      String(suggestedColorString).startsWith("suggested_color") ||
      String(suggestedColorString).startsWith("wheel_suggested_color")
    );
  };
  const getSuggestedColor = (colorString = "") => {
    const isWheelSuggested = colorString.startsWith("wheel_suggested_color_");
    const palette = isWheelSuggested ? selectedWheelPalette : selectedPalette;

    // Ensure palette colors are available
    if (!Array.isArray(palette?.colors) || palette?.colors.length === 0) {
      return segmentColor || selectedSegmentColor;
    }

    // Extract index from color string
    const match = colorString.match(/(?:wheel_)?suggested_color_(\d+)/);
    const index = match ? parseInt(match[1], 10) : -1;

    // Return the color hex if valid index, else fallback to selected segment color
    return index >= 0 && index < palette.colors.length
      ? palette.colors[index]?.hex
      : segmentColor || selectedSegmentColor;
  };

  const getPaletteColor = (color) => {
    return isValidSuggestedColor(color) ? getSuggestedColor(color) : color;
  };

  return useMemo(
    () => ({
      getPaletteColor,
    }),
    [selectedPalette, segmentColor, selectedSegmentColor]
  );
};
